import { showError } from "infra/helpers/alerta";

function toDataURL(url: string) {
  return fetch(url)
    .then((response) => {
      return response.blob();
    })
    .then((blob) => {
      return URL.createObjectURL(blob);
    })
    .catch(() => {
      showError("Não foi possível fazer o download dessa imagem.");
      return null;
    });
}

export async function download(url: string, fileName: string) {
  const a = document.createElement("a");
  const _url = await toDataURL(url);
  if (_url) {
    a.href = _url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}

export async function downloadLocalBlob(
  blob: Blob | ArrayBuffer,
  fileName: string,
  type: string
) {
  const file = new Blob([blob], { type });
  const fileURL = URL.createObjectURL(file);

  const a = document.createElement("a");

  a.setAttribute("style", "display: none");

  document.body.appendChild(a);

  a.href = fileURL;

  a.download = fileName;

  a.click();

  window.URL.revokeObjectURL(fileURL);

  document.body.removeChild(a);
}

export async function downloadLocalExcelFromBlob(
  buffer: ArrayBuffer,
  filename: string
) {
  await downloadLocalBlob(
    buffer,
    filename,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  );
}
